<template>
    <div :class="['dialog-aktiv-patient', `size-${size}`, `variant-${variant}`]">
        <div class="patientimg">
            <img v-if="variant === 'alt'" src="@/assets/dialogs/patient_dark.svg" alt="Patient" />
            <img v-else src="@/assets/dialogs/patient.svg" alt="Patient" />
        </div>
        <div>
            <strong v-if="showHeader">Aktiv patient</strong>
            <ul class="patient-details">
                <li v-if="showBirthDate" class="person-id">{{ patient.dateOfBirth }}</li>
                <li v-else class="person-id">{{ patient.personId_formatted }}</li>
                <li v-if="patient.namn">{{ patient.namn }}</li>
                <!-- Den här logiken behövs eftersom DialogAktivPatient även används i NLL:s Receptförskrivning,
                     där patientobjektet saknar vissa egenskaper och saknar 'namn'. -->
                <li v-else>{{ patient.fornamn }} {{ patient.efternamn }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DialogAktivPatient",
        props: {
            patient: {
                type: Object,
                required: true,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
            size: {
                type: String,
                default: "default",
                validator: function (value) {
                    return ["default", "medium", "small"].indexOf(value) !== -1;
                },
            },
            variant: {
                type: String,
                default: "default",
                validator: function (value) {
                    return ["default", "alt"].indexOf(value) !== -1;
                },
            },
            showBirthDate: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/style/variables";

    .dialog-aktiv-patient {
        display: flex;
        align-items: flex-end;
        gap: 5px;

        &.size-default {
            .patientimg {
                width: 50px;
                height: 50px;

                img {
                    width: 25px;
                    height: 28px;
                }
            }

            .patient-details {
                font-size: 20px;
                line-height: 28px;
            }
        }

        &.size-medium {
            align-items: center;

            .patientimg {
                width: 42px;
                height: 42px;

                img {
                    margin-left: 4px;
                    width: 16px;
                    height: 18px;
                }
            }

            .patient-details {
                font-size: 16px;
                line-height: 22px;
            }
        }

        &.size-small {
            .patientimg {
                width: 36px;
                height: 36px;

                img {
                    width: 19px;
                    height: 21px;
                }
            }

            .patient-details {
                font-size: 16px;
                line-height: 22px;
            }
        }

        .patientimg {
            background-color: $color-primary-lighten;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 5px;
        }

        &.variant-alt {
            .patientimg {
                background-color: $color-pale-blue;

                img {
                    color: $color-default-blue;
                }
            }
        }

        strong {
            display: block;
            font-weight: 500;
            line-height: 30px;
            color: $color-text-black;
        }

        .patient-details {
            color: $color-text-header;
            list-style: none;
            margin: 0;
            padding: 0;

            .person-id {
                font-family: "Roboto medium";
                font-weight: 500;
            }
        }
    }
</style>
